"use client";

import {
  LuLayoutGrid,
  LuUser,
  LuBuilding2,
  LuGraduationCap,
} from "react-icons/lu";

export type BrowseType = "all" | "mentor" | "agency" | "representative";

export type TypePillToggleProps = {
  value: BrowseType;
  onChange: (value: BrowseType) => void;
  /** Optional counts to show next to each label. */
  counts?: {
    all?: number;
    mentor?: number;
    agency?: number;
    representative?: number;
  };
};

type Option = {
  key: BrowseType;
  label: string;
  Icon: typeof LuLayoutGrid;
};

const OPTIONS: Option[] = [
  { key: "all", label: "All", Icon: LuLayoutGrid },
  { key: "mentor", label: "Individual Experts", Icon: LuUser },
  { key: "agency", label: "Agencies", Icon: LuBuilding2 },
  { key: "representative", label: "Representatives", Icon: LuGraduationCap },
];

export function TypePillToggle({
  value,
  onChange,
  counts,
}: TypePillToggleProps) {
  return (
    <div
      role="tablist"
      aria-label="Filter by type"
      className="inline-flex items-center gap-1 p-1 rounded-xl bg-white/80 dark:bg-white/5 border border-gray-200 dark:border-white/10 backdrop-blur-xs"
    >
      {OPTIONS.map(({ key, label, Icon }) => {
        const active = value === key;
        const count = counts?.[key];
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              active
                ? "bg-indigo-600 text-white shadow-sm"
                : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{label}</span>
            {typeof count === "number" && (
              <span
                className={`ml-0.5 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full text-xs font-semibold ${
                  active
                    ? "bg-white/25 text-white"
                    : "bg-gray-200 dark:bg-white/10 text-gray-600 dark:text-gray-300"
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
